import { createContext, useContext, useEffect , useMemo} from "react";
import { useState } from "react";
import axiosInstance from "./axioInstance";
import FullScreenLoader from "../fullscreen";
import axios from "axios";
import { set } from "react-hook-form";
import { getUserInfo } from "./Api";
import { log } from "@openid/appauth";
const AuthContext = createContext();



export const AuthProvider = ({ children }) => {




    const [authToken  , setAuthToken] = useState(() => localStorage.getItem("token"))
    const [refreshToken, setRefreshToken] = useState(() => localStorage.getItem('refresh_token'));

    const [user , setUser] = useState(null)
    const [loading, setLoading] = useState(false);
    const [loadingText , setLoadingText] = useState("Loading...")


    const showLoader = () => setLoading(true);
    const hideLoader = () => setLoading(false);
    const updateLoaderText = (text) => setLoadingText(text);


    const contextValue = useMemo(() => ({
        loading,
        showLoader,
        hideLoader,
        updateLoaderText,
        loadingText
      }), [loading]);

      useEffect(() => {

        const verifyToken = async () => {
            if(!authToken) return;
            try{
                showLoader()
                const response = await getUserInfo();
                setUser(response.data)
                
            }
            catch(error){
                console.warn("Invalid token. Logging out...");
                logout()
            }

            finally{
                hideLoader()
            }
          
        }
        verifyToken();
        console.log("called how much time")
      },[])


    const login = async (data) => {
        setAuthToken(data.access_token)
        setRefreshToken(data.refresh_token);
        //setUser(data.user)
        localStorage.setItem("token" , data.access_token)
        localStorage.setItem("refresh_token" , data.refresh_token)

        if(data.user && data.user.stablename){
            localStorage.setItem("user_name" , data.user.stablename)
        }

    }


    const updateUserData = (data) => {
        setUser(data)
    }

    const logout = () => {
        setAuthToken(null)
        setUser(null)
        localStorage.removeItem("token")
        localStorage.removeItem("refresh_token")
        localStorage.removeItem("user_name" )
        setRefreshToken(null);

    }


    const isAuthenticated = !!authToken


    return (
        <AuthContext.Provider value={{ authToken , refreshToken , user , login , logout , isAuthenticated , contextValue , updateUserData}}>
            {loading && <FullScreenLoader text={loadingText} />} 
            {children}
        </AuthContext.Provider>
    )
}


export const useAuth = () => useContext(AuthContext)